import { env } from "./environments/environment"

export const DpuProcedure = () => {
	return <iframe src={env.new_proc_url} className="w-full h-[81vh]" />
}
